import { render, staticRenderFns } from "./CallHistory.vue?vue&type=template&id=510c89a5&scoped=true"
import script from "./CallHistory.vue?vue&type=script&lang=js"
export * from "./CallHistory.vue?vue&type=script&lang=js"
import style0 from "./CallHistory.vue?vue&type=style&index=0&id=510c89a5&prod&scoped=true&lang=scss"
import style1 from "./CallHistory.vue?vue&type=style&index=1&id=510c89a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510c89a5",
  null
  
)

export default component.exports